// Copyright: IQGeo Limited 2010-2022
import $ from 'jquery';
import myw from 'myWorld/base/core';
import './formComponent';

/**
 * @class  RadioGroup
 * @param  {array<string>} options.options Options to add to the radio group
 * @param  {string} options.selected Selected item identifier
 * @param  {function} options.onChange onChange handler
 
 * @example
 * new myw.RadioGroup(options:['On', 'Off'], selected: 'On'})
 *
 * @extends {FormComponent}
 **/
myw.RadioGroup = myw.FormComponent.extend({
    tagName: 'div',
    className: 'ui-radiogroup',
    blackListParams: ['onChange'],

    events: {
        'input.change': '_onChange',
        'click label': '_onLabelClick'
    },

    initialize(options) {
        myw.FormComponent.prototype.initialize.call(this, options);

        this._inputNodes = {};
        //Populate the options
        this.options.options.forEach(option => {
            const { id, label } = option;
            const spanNode = $('<span />');
            const inputNode = $(`<input type="radio" name="${this.options.name} value="${id}">`);
            this._inputNodes[id] = inputNode;
            if (this.options.selected == id) {
                inputNode.prop('checked', true);
            }
            spanNode.append(inputNode);
            spanNode.append(`<label for="${id}">${label}</label>`);
            this.$el.append(spanNode);
        });

        myw.FormComponent.prototype.render.call(this, options);

        return this;
    },

    _onChange() {
        const options = this.options;
        options.onChange?.call({}, this);
    },

    _onLabelClick(args) {
        args.currentTarget.previousSibling.click();
    },

    setValue(value) {
        this._inputNodes[value].prop('checked', true);
    },

    getValue() {
        return Object.keys(this._inputNodes).find(field => this._inputNodes[field].prop('checked'));
    }
});

myw.View.prototype.componentMapping['radiogroup'] = myw.RadioGroup;

export default myw.RadioGroup;
